import { AdgroupFormData, CampaignFormData } from '@tt4b/ttam-enums';
import { Ref, computed, ref } from '@vue/composition-api';
import { useStdAdgroupIs } from '@tt4b/ttam-hooks';

export function usePropsVisible(props: { adgroupData: Ref<AdgroupFormData>; campaignData: Ref<CampaignFormData> }) {
  // TODO 依赖splitTest
  const isSplitTestEnabled = ref(false);
  const { isPSA } = useStdAdgroupIs({
    adgroupFormData: props.adgroupData,
    campaignFormData: props.campaignData,
  });
  return {
    visible: computed(() => !isSplitTestEnabled.value && !isPSA.value),
  };
}
